//------------------------------------------------------------------------------
//  This code was generated by typescript template tool 'Typewriter'.
//
//  Changes to this file may cause incorrect behavior and will be lost if
//  the code is regenerated.
//------------------------------------------------------------------------------

import { BaseViewGridModel } from "./Dental-WebCore-Models-BaseViewGridModel";
import { SalaryViewModel } from "./Dental-WebCore-Models-SalaryViewModel";

export class SalaryViewGridModel extends BaseViewGridModel<SalaryViewModel>  {
    
    counNewSalaries: number;
}




  
